import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import Inquiry from "./Inquiry";
const Banner = () => {
  return (
    <div className="relative w-full h-full grid grid-rows-2 xl:grid-rows-1 xl:grid-cols-5">
      <Swiper
        spaceBetween={30}
        centeredSlides={true}
        autoplay={{
          delay: 4000,
          disableOnInteraction: false,
        }}
        loop={true}
        navigation={false}
        modules={[Autoplay]}
        className="mySwiper relative w-full h-full xl:h-[700px] xl:col-span-3"
      >
        <SwiperSlide className="relative w-full h-full grid items-end bg-[#feefc5]">
          <img
            className="hidden xl:block relative w-auto h-fit xl:max-h-[700px] object-contain ml-auto"
            src="/images/banner1.png"
            alt="banner"
          />
          <img
            className="block xl:hidden relative w-fit h-full object-contain mx-auto max-h-[550px]"
            src="/images/bannerM1.png"
            alt="banner"
          />
        </SwiperSlide>
        <SwiperSlide className="relative w-full h-full grid items-end bg-[#595959]">
          <img
            className="hidden xl:block relative w-auto h-fit xl:max-h-[700px] object-contain ml-auto"
            src="/images/banner2.png"
            alt="banner"
          />
          <img
            className="block xl:hidden relative w-fit h-full object-contain mx-auto max-h-[550px]"
            src="/images/bannerM2.png"
            alt="banner"
          />
        </SwiperSlide>
        <SwiperSlide className="relative w-full h-full grid items-end bg-[#c9d5ae]">
          <img
            className="hidden xl:block relative w-auto h-fit xl:max-h-[700px] object-contain ml-auto"
            src="/images/banner3.png"
            alt="banner"
          />
          <img
            className="block xl:hidden relative w-fit h-full object-contain mx-auto max-h-[550px]"
            src="/images/bannerM3.png"
            alt="banner"
          />
        </SwiperSlide>
      </Swiper>
      <div className="relative w-full h-full max-h-[530px] lg:max-h-[700px] bg-primary xl:col-span-2 grid items-center z-10">
        <div className="relative w-fit h-fit mx-auto xl:ml-0 max-w-screen-md">
          <div className="pt-2 pb-1 lg:py-1 text-white flex justify-center items-center">
            <h3 className="font-light 2xl:text-3xl">
              몽&nbsp;·&nbsp;땅&nbsp;&nbsp;
            </h3>
            <h3 className="2xl:text-3xl">
              <span className="font-light">“</span>
              상세견적 문의<span className="font-light">”</span>
            </h3>
          </div>
          <div className=" relative w-full h-fit lg:px-5">
            <div className="py-5 bg-white rounded-xl">
              <Inquiry />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
